// Every deposit and withdrawal, newest first: the Wallet's "See all". Loads 30 at a time as the list is scrolled down.
import { useEffect, useRef, useState } from "react";
import { api } from "../api.js";
import type { WalletView } from "../money.js";
import { ActivityRow } from "./App28-Wallet.js";

type Item = WalletView["activity"][number];

export function App28a_Activity() {
  const [items, setItems] = useState<Item[]>([]);
  const [more, setMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const end = useRef<HTMLDivElement>(null);

  const load = async (before?: number) => {
    if (loading) return;
    setLoading(true);
    setFailed(false);
    try {
      const r = await api<{ activity: Item[]; more: boolean }>(`/v1/wallet/activity${before ? `?before=${before}` : ""}`);
      setItems((list) => [...list, ...r.activity.filter((a) => !list.some((x) => x.kind === a.kind && x.id === a.id))]);
      setMore(r.more);
    } catch {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    void load();
  }, []);
  // The next page loads when the end of the list scrolls into view.
  useEffect(() => {
    const el = end.current;
    if (!el || !more) return;
    const io = new IntersectionObserver((e) => {
      if (e[0]?.isIntersecting && !loading && items.length) void load(items[items.length - 1]!.at);
    });
    io.observe(el);
    return () => io.disconnect();
  }, [items, more, loading]);

  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "40px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad" style={{ height: "100%", boxSizing: "border-box", paddingBottom: "0", display: "flex", flexDirection: "column", overflow: "hidden" }}>
    <div className="top" style={{ justifyContent: "center" }}><span className="unb" style={{ fontWeight: "900", fontSize: "16px" }}>Activity</span></div>
    <div className="fit" style={{ flex: "1", minHeight: "0", height: "auto", paddingBottom: "calc(var(--dd-safe-bottom) + 12px)" }}>
      <div className="g" style={{ borderRadius: "20px", padding: "4px 0" }}>
        {items.map((a, i) => <ActivityRow key={`${a.kind}:${a.id}`} a={a} first={i === 0} />)}
        {!loading && !failed && items.length === 0 && <div className="li"><span className="muted" style={{ fontSize: "13px" }}>No deposits or withdrawals yet.</span></div>}
        {loading && <div className="li"><span className="muted" style={{ fontSize: "13px" }}>Loading...</span></div>}
        {failed && <button className="li" onClick={() => void load(items.at(-1)?.at)} style={{ width: "100%", background: "none", border: "0", color: "#CCFF00", font: "inherit", fontSize: "13px", cursor: "pointer" }}>Couldn't load. Tap to try again.</button>}
      </div>
      <div ref={end} style={{ height: "1px" }}></div>
      {!more && items.length > 0 && <p className="muted" style={{ textAlign: "center", fontSize: "12px", margin: "12px 0 0" }}>That's everything.</p>}
    </div>
  </div>
</div>
    </>
  );
}
